import * as APIRoutes from '@mm/api-routes';
import { ObjectUtils } from '@mm/utils';
import { SearchAttributes } from '../interfaces/leads';
import {
  MyLeadsAttributes,
  MyLeadsCreateAudienceRequestParams,
  MyLeadsCreateAudienceResponse,
  MyLeadsSearchQuery,
  MyLeadsUrlsQueryType,
} from '../interfaces/myLeads';
import { ContactsModel } from '../model/ContactsModel';
import AuthenticatedController from './AuthenticatedController';
import { DEFAULT_HEADERS } from './Controller';

export default class MyLeadsController extends AuthenticatedController {
  static async getAllAttributes(fbPageId: number): Promise<MyLeadsAttributes> {
    return super.get(APIRoutes.MY_LEADS_ATTRIBUTES(fbPageId));
  }

  static async searchLeads(
    fbPageId: number,
    params: MyLeadsSearchQuery,
  ): Promise<Partial<ContactsModel>> {
    const transformedParams = {
      ...params,
      ...(params.query
        ? { query: ObjectUtils.mapObjKeysToSnakeCase(params.query) }
        : {}),
    };

    return super.post(
      APIRoutes.MY_LEADS_SEARCH(fbPageId),
      transformedParams,
      null,
      DEFAULT_HEADERS,
      null,
      false,
      true,
    );
  }

  static async retrieveLocationAttributes(
    fbPageId: number,
    query: string,
  ): Promise<SearchAttributes> {
    return super.post(APIRoutes.MY_LEADS_ADDRESS_ATTRIBUTE_SEARCH(fbPageId), {
      query,
    });
  }

  static async createAudience(
    fbPageId: number,
    params: MyLeadsCreateAudienceRequestParams,
  ): Promise<MyLeadsCreateAudienceResponse> {
    return super.post(
      APIRoutes.MY_LEADS_CREATE_AUDIENCE(fbPageId),
      params,
      null,
      DEFAULT_HEADERS,
      null,
      false,
      true,
    );
  }

  static async retrieveLandingPages(
    botId: number,
    query: string,
    type?: MyLeadsUrlsQueryType,
  ): Promise<string[]> {
    const queryParams = type ? `&type=${type}` : '';
    return super.get(
      `${APIRoutes.LANDING_PAGE_URLS(botId)}?term=${query}${queryParams}`,
    );
  }

  static async retrieveVisitedUrls(
    botId: number,
    query: string,
    type?: MyLeadsUrlsQueryType,
  ): Promise<string[]> {
    const queryParams = type ? `&type=${type}` : '';
    return super.get(
      `${APIRoutes.VISITED_URLS(botId)}?term=${query}${queryParams}`,
    );
  }
}
